import { AumeLogo } from '@/assets/branding/aume';

export default {
  name: 'Aume Media',
  isSAML: true,
  allowPersonalCourses: false,
  logo: AumeLogo,
  colors: {
    // Brand colors
    brand_primary: '#0779FF',
    brand_primary_hover: '#175CD3',
    brand_primary_highlight: '#84CAFF',
    brand_primary_mid: '#1C86FF',
    brand_primary_dark: '#043E80',
    brand_secondary: '#2F6CCE',
  },
};
